import styled, { useTheme } from 'styled-components';

export const ScrollUpIcon: React.FC = () => {
  const theme = useTheme();
  return (
    <S.Container
      className="arrow"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={theme.secondary.softBlue2}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 8L1.41 9.41L7 3.83V16H9V3.83L14.58 9.42L16 8L8 0L0 8Z" />
    </S.Container>
  );
};

const S = {
  Container: styled.svg`
    display: block;
    margin: auto;
  `,
};
